setTimeout(() => {
  document.querySelectorAll(".toggle-dropdown").forEach((button) => {
    button.addEventListener("click", function () {
      let dropdown = this.nextElementSibling;
      dropdown.classList.toggle("hidden");
    });
  });

  document
    .querySelectorAll(".recommendation-extra .variant-option")
    .forEach((option) => {
      option.addEventListener("click", function () {
        let variantId = this.getAttribute("data-variant-id");

        if (variantId) {
          addToCart(variantId);

          const button = this.closest(".variant-selector");
          button.querySelector(
            ".cart-recommendations__item-button"
          ).style.height = "auto";
          // fbt-products snippet
          if (option.dataset.fbt == "true") {
            setTimeout(() => {
              document.querySelector(".js-drawer-open-cart").click();
            }, 1000);
          }
        }

        let selectedText = this.textContent;
        this.closest(".variant-selector").querySelector(
          ".toggle-dropdown"
        ).textContent = selectedText;
        this.parentElement.classList.add("hidden");
      });
    });

  function addToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:build"));

        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            const itemCount = cart.item_count;
            const countEl = document.getElementById("cst_cart-item-count");
            if (countEl) {
              countEl.textContent = itemCount;
            }
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }
}, 2000);
